import React from "react";
import "./Topsection.css";
import najeebimg from "../../Assets/najeeb.jpg";
import topsecimg from "../../Assets/topsecimg.png";
import { data } from "../../data";


const Topsection = () => {
  const incoming_data = data;

  return (
    <>
      <div className="maindiv">
        <img className="topimage" alt="Mohd Najeeb Ullh" src={najeebimg} />
        <div className="subdiv">
          <h1>Mohd Najeeb Ullah</h1>
          <h4>Full Stack Developer (MERN)</h4>
          {incoming_data.map((ele) => {
            return (
              <a href={ele.link} target="_blank" className="social">
                {ele.icon}
              </a>
            );
          })}
          <p>najeebu50@gmail.com | +91-7207232093</p>
          <div className="subdivtwo">
          <img alt="full stack developer image" src={topsecimg} />
        </div>
        </div>
      </div>
    </>
  );
};

export default Topsection;


